import { Validator } from './validator/Validator';
import { ValidatorBuilder } from './validator/ValidatorBuilder';

export { Validator } from './validator/Validator';
export { ValidatorBuilder } from './validator/ValidatorBuilder';
export { parseInlineRules } from './parser/inlineParser';
export * from './types';
export * from './rules';
export * from './functional';

export function validateTemplate(
    data: Record<string, any>,
    template: any[],
    options?: any
) {
    const validator = new Validator(data, options);
    return validator.validateTemplate(template);
}

export function validateRules(
    data: Record<string, any>,
    rules: Record<string, any[]>,
    options?: any
) {
    const validator = new Validator(data, options);
    return validator.validateRules(rules);
}

export function createValidator(data: Record<string, any>, options?: any) {
    return new Validator(data, options);
}

export function createValidatorBuilder() {
    return new ValidatorBuilder();
}